import React from 'react';

const Edite = () => {
    return (
        <div>
            <h1>woelcome to eddite page.....</h1>
        </div>
    );
};

export default Edite;